// University of Oregon's undergraduate majors (#2748). Read on 2026-10-01 from
// the official 2026-2027 Academic Catalog's Undergraduate Programs page
// (catalog.uoregon.edu/ug-programs/, the Undergraduate Majors tab), which
// lists every major with its degrees and links it to the catalog section of
// the college or school that offers it; each group cites that section.
// Minors and certificates are left out. Degree abbreviations are the
// catalog's own (BA, BS, BFA, BArch, BIArch, BLA, BMus, BMME, BEd). The
// catalog writes "Journalism: Advertising:" with a trailing colon; the name
// here drops it. The flags quote UO's Departmental Deadlines page (the
// college file's `departments` source). The KB's majors list was the
// starting point; the catalog wins.
const majors = {
    "slug": "university-of-oregon",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in UO's official 2026-2027 Academic Catalog, grouped by the college or school that offers it, with the degrees it leads to. Minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "UO 2026-2027 Academic Catalog, College of Arts and Sciences",
                "url": "https://catalog.uoregon.edu/arts-sciences/"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "BA, BS"
                },
                {
                    "name": "Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BA, BS"
                },
                {
                    "name": "Biology",
                    "degree": "BA, BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA, BS"
                },
                {
                    "name": "Chinese",
                    "degree": "BA"
                },
                {
                    "name": "Cinema Studies",
                    "degree": "BA, BS"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Comparative Literature",
                    "degree": "BA, BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA, BS"
                },
                {
                    "name": "Cybersecurity",
                    "degree": "BS"
                },
                {
                    "name": "Data Science",
                    "degree": "BA, BS"
                },
                {
                    "name": "Earth Sciences",
                    "degree": "BA, BS"
                },
                {
                    "name": "Economics",
                    "degree": "BA, BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BA, BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA, BS"
                },
                {
                    "name": "Ethnic Studies",
                    "degree": "BA, BS"
                },
                {
                    "name": "Folklore and Public Culture",
                    "degree": "BA"
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": "BA"
                },
                {
                    "name": "General Social Science",
                    "degree": "BA, BS"
                },
                {
                    "name": "Geography",
                    "degree": "BA, BS"
                },
                {
                    "name": "German",
                    "degree": "BA, BS"
                },
                {
                    "name": "Global Studies",
                    "degree": "BA, BS"
                },
                {
                    "name": "History",
                    "degree": "BA, BS"
                },
                {
                    "name": "Humanities",
                    "degree": "BA"
                },
                {
                    "name": "Human Physiology",
                    "degree": "BA, BS"
                },
                {
                    "name": "Italian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Japanese",
                    "degree": "BA"
                },
                {
                    "name": "Judaic Studies",
                    "degree": "BA"
                },
                {
                    "name": "Latin American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Linguistics",
                    "degree": "BA, BS"
                },
                {
                    "name": "Marine Biology",
                    "degree": "BA, BS"
                },
                {
                    "name": "Materials Science and Technology",
                    "degree": "BA, BS"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA, BS"
                },
                {
                    "name": "Mathematics and Computer Science",
                    "degree": "BA, BS"
                },
                {
                    "name": "Medieval Studies",
                    "degree": "BA"
                },
                {
                    "name": "Multidisciplinary Science",
                    "degree": "BA, BS"
                },
                {
                    "name": "Native American and Indigenous Studies",
                    "degree": "BA, BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BA, BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA, BS"
                },
                {
                    "name": "Physics",
                    "degree": "BA, BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA, BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA, BS"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA, BS"
                },
                {
                    "name": "Romance Languages",
                    "degree": "BA"
                },
                {
                    "name": "Russian, East European, and Eurasian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA, BS"
                },
                {
                    "name": "Spanish",
                    "degree": "BA, BS"
                },
                {
                    "name": "Spatial Data Science and Technology",
                    "degree": "BA, BS"
                },
                {
                    "name": "Theater Arts",
                    "degree": "BA, BS"
                },
                {
                    "name": "Women's, Gender, and Sexuality Studies",
                    "degree": "BA, BS"
                }
            ]
        },
        {
            "name": "Charles H. Lundquist College of Business",
            "source": {
                "label": "UO 2026-2027 Academic Catalog, Charles H. Lundquist College of Business",
                "url": "https://catalog.uoregon.edu/coll-business/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BA, BS",
                    "flag": "Direct admission is considered when you choose Business; most of the class starts as pre-business.",
                    "flagSource": "departments"
                },
                {
                    "name": "Business Administration",
                    "degree": "BA, BS",
                    "flag": "Direct admission is considered when you choose Business; most of the class starts as pre-business.",
                    "flagSource": "departments"
                }
            ]
        },
        {
            "name": "College of Design",
            "source": {
                "label": "UO 2026-2027 Academic Catalog, College of Design",
                "url": "https://catalog.uoregon.edu/design/"
            },
            "majors": [
                {
                    "name": "Architecture",
                    "degree": "BArch",
                    "flag": "Two essays and a portfolio with the UO application; the department reviews you separately.",
                    "flagSource": "departments"
                },
                {
                    "name": "Art",
                    "degree": "BA, BS, BFA"
                },
                {
                    "name": "Art and Technology",
                    "degree": "BA, BS, BFA"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Design",
                    "degree": "BA, BS"
                },
                {
                    "name": "Interior Architecture",
                    "degree": "BIArch",
                    "flag": "Two essays and a portfolio with the UO application; the department reviews you separately.",
                    "flagSource": "departments"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "BLA"
                },
                {
                    "name": "Planning, Public Policy and Management",
                    "degree": "BA, BS"
                },
                {
                    "name": "Product Design",
                    "degree": "BFA",
                    "flag": "A separate SlideRoom application by January 15, with no early action; the department reviews you separately.",
                    "flagSource": "departments"
                }
            ]
        },
        {
            "name": "College of Education",
            "source": {
                "label": "UO 2026-2027 Academic Catalog, College of Education",
                "url": "https://catalog.uoregon.edu/education/"
            },
            "majors": [
                {
                    "name": "Communication Disorders and Sciences",
                    "degree": "BA, BS"
                },
                {
                    "name": "Educational Foundations",
                    "degree": "BA, BS"
                },
                {
                    "name": "Family and Human Services",
                    "degree": "BA, BS"
                }
            ]
        },
        {
            "name": "School of Journalism and Communication",
            "source": {
                "label": "UO 2026-2027 Academic Catalog, School of Journalism and Communication",
                "url": "https://catalog.uoregon.edu/journalism_comm/"
            },
            "majors": [
                {
                    "name": "Journalism",
                    "degree": "BA, BS"
                },
                {
                    "name": "Journalism: Advertising",
                    "degree": "BA, BS"
                },
                {
                    "name": "Journalism: Media Studies",
                    "degree": "BA, BS"
                },
                {
                    "name": "Journalism: Public Relations",
                    "degree": "BA, BS"
                }
            ]
        },
        {
            "name": "School of Music and Dance",
            "source": {
                "label": "UO 2026-2027 Academic Catalog, School of Music and Dance",
                "url": "https://catalog.uoregon.edu/music_dance/"
            },
            "majors": [
                {
                    "name": "Dance",
                    "degree": "BA, BS, BFA"
                },
                {
                    "name": "Music",
                    "degree": "BA, BS"
                },
                {
                    "name": "Music Composition",
                    "degree": "BMus"
                },
                {
                    "name": "Music Education",
                    "degree": "BMME"
                },
                {
                    "name": "Music: Jazz Studies",
                    "degree": "BMus"
                },
                {
                    "name": "Music Performance",
                    "degree": "BMus"
                },
                {
                    "name": "Popular Music",
                    "degree": "BA, BS"
                }
            ]
        },
        {
            "name": "Ballmer Institute for Children's Behavioral Health",
            "source": {
                "label": "UO 2026-2027 Academic Catalog, Ballmer Institute for Children's Behavioral Health",
                "url": "https://catalog.uoregon.edu/ballmer-institute/"
            },
            "majors": [
                {
                    "name": "Child Behavioral Health",
                    "degree": "BA, BS, BEd"
                }
            ]
        }
    ]
};

export default majors;
